import { useEffect, useState } from "react";
import Layout from "../shared/Layout";
import AnnouncementBox from "./components/AnnouncementBox";
import CotrStats from "./components/CotrStats";
import { logAnalyticsEvent } from "../engagement/Amplitude";
import Config from "../shared/Config";
import SummariesFeed from "./components/SummariesFeed";
import TasksFeed from "./components/TasksFeed";
import GuidesFeed from "./components/GuidesFeed";
import CreateAGuide from "../tasks/components/CreateAGuide";
import CreateATask from "../tasks/components/CreateATask";
import CollectionsFeed from "./components/CollectionsFeed";
import CreateACollection from "../tasks/components/CreateACollection";

export default function Home() {
  const [activeTab, setActiveTab] = useState("snippets");
  const [show, setShow] = useState(false);

  useEffect(() => {
    logAnalyticsEvent("Change Tab", { tab: activeTab });
  }, [activeTab]);

  return (
    <Layout>
      <div
        className="lg:hidden link-accent link p-2 cursor-pointer"
        onClick={() => {
          logAnalyticsEvent("Open About Modal");
          setShow(true);
        }}
      >
        How does this work?
      </div>
      <CotrStats />
      <div className="flex mt-8">
        <div className="w-full lg:w-2/3">
          <div className="flex  justify-between items-center mb-8 pr-4">
            <div
              role="tablist"
              className={`tabs tabs-lifted tabs-sm md:tabs-lg`}
            >
              <a
                role="tab"
                onClick={() => setActiveTab("snippets")}
                className={`tab ${
                  activeTab === "snippets" ? "tab-active text-primary" : ""
                }`}
              >
                Snippets
              </a>
              <a
                role="tab"
                onClick={() => setActiveTab("collections")}
                className={`tab ${
                  activeTab === "collections" ? "tab-active text-primary" : ""
                }`}
              >
                Collections
              </a>
            </div>
            {activeTab === "snippets" ? <CreateATask /> : <CreateACollection />}
          </div>
          {activeTab == "snippets" && <TasksFeed />}
          {activeTab == "collections" && <CollectionsFeed />}
        </div>
        <AnnouncementBox />
      </div>
      <dialog
        id="about_modal"
        className="modal"
        open={show}
      >
        <div className="modal-box rounded-md border-primary border-2">
          <h3 className="text-lg font-bold ">Welcome to Code on the Rocks!</h3>
          <div className="pt-4">{Config.intro}</div>
          <h3 className="text-lg mt-12">How it Works</h3>
          {Config.howItWorks.map((item, index) => (
            <details
              key={index}
              tabIndex={0}
              className="collapse collapse-arrow rounded-none"
            >
              <summary className="collapse-title text-xl font-bold">
                {item.title}
              </summary>
              <div className="collapse-content ">
                <p>{item.description}</p>
              </div>
            </details>
          ))}
        </div>
        <form
          method="dialog"
          className="modal-backdrop"
          onSubmit={() => setShow(false)}
        >
          <button>close</button>
        </form>
      </dialog>
    </Layout>
  );
}

{
}
